import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubmitMemberAdComponent } from './submit-member-ad.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PendingAdsListComponent } from './pending-ads-list.component';
import {NgbPagination, NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import { PendingAdDetailsComponent } from './pending-ad-details.component';
import { AdsComponent } from './ads.component';
import { UpgradeInterestModalComponent } from './Modals/upgrade-interest-modal.component';
import { EditAdModalComponent } from './Modals/edit-ad-modal.component';



@NgModule({
  declarations: [
    SubmitMemberAdComponent,
    PendingAdsListComponent,
    PendingAdDetailsComponent,
    AdsComponent,
    UpgradeInterestModalComponent,
    EditAdModalComponent
  ],
    imports: [
        CommonModule
        , FormsModule
        , RouterModule
        , ReactiveFormsModule, NgbPagination
        , NgbTooltipModule
    ]
})
export class MemberAdsModule { }
